export const infoTypes = {
  informations: {
    name: "informations",
    color: "#2277CC",
  },
  warning: {
    name: "warning",
    color: "#DD3333",
  },
};
